/* React */
import { CSSProperties } from 'react'
import parse from 'html-react-parser'

/* Material */
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'

import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { lighten } from '@mui/material/styles'

import { mode } from 'template/material-theme'
import { menuPageBuilderFooterSpacingDefaults } from 'src/shared/dbTypes/menuPageBuilder'
import config from 'src/config'

/* Components */
import Link from 'src/components/TypoLink'
import NoBr from 'src/components/js_elements/NoBr'

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({

    fussnoten: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      backgroundColor: 'var(--builder-footer-footnotes-bg, inherit)',
      color: 'var(--builder-footer-footnotes-text, inherit)',
      '& a': {
        color: 'var(--builder-footer-footnotes-link, inherit)',
      },
    },

    container: {

      paddingTop: 'var(--builder-footer-footnotes-padding-top, 18px)',
      paddingBottom: 'var(--builder-footer-footnotes-padding-bottom, 28px)',

      '& > p': {

        lineHeight: '1rem',

        '&:not(:last-child)': {
          marginBottom: theme.spacing(2),
        },

        fontSize: '0.86rem',
        //color: theme.palette.grey[800],

      },

    },

  })
})

interface Props {
  backgroundColor?: string
  textColor?: string
  linkColor?: string
  primaryHtml?: string
  secondaryHtml?: string
  paddingTop?: number
  paddingBottom?: number
}

const Fussnoten: React.FC<Props> = ({
  backgroundColor,
  textColor,
  linkColor,
  primaryHtml,
  secondaryHtml,
  paddingTop,
  paddingBottom,
}) => {
  const classes = useStyles()
  const darkMode = mode === 'dark'
  const defaultBgColor = darkMode
    ? '#424242'
    : '#e0e0e0'
  const defaultLinkColor = darkMode
    ? lighten('#90caf9', 0.45)
    : '#1565c0'
  const germanyOnly = config.deliveryCountries.length === 1 && config.deliveryCountries[0] === 'DE'
  const style = {
    ['--builder-footer-footnotes-bg' as string]: backgroundColor || defaultBgColor,
    ['--builder-footer-footnotes-text' as string]: textColor || undefined,
    ['--builder-footer-footnotes-link' as string]: linkColor || defaultLinkColor,
    ['--builder-footer-footnotes-padding-top' as string]: `${paddingTop ?? menuPageBuilderFooterSpacingDefaults.footnotesPaddingTop}px`,
    ['--builder-footer-footnotes-padding-bottom' as string]: `${paddingBottom ?? menuPageBuilderFooterSpacingDefaults.footnotesPaddingBottom}px`,
  } as CSSProperties

  return <div className={classes.fussnoten} style={style}>
    <Container maxWidth='lg' className={classes.container}>

      {primaryHtml
        ? <Box>{parse(primaryHtml)}</Box>
        : <Typo>
            *¹ Alle Preise verstehen sich inkl. deutscher MwSt. und zzgl. Versandkosten ins
            deutsche Festland. Unter einem Bestellwert von <NoBr>79,00 €</NoBr> berechnen wir
            einen Mindermengenzuschlag in Höhe von <NoBr>5,00 €.</NoBr> Bei Speditionslieferungen
            berechnen wir immer <NoBr>89,00 €</NoBr> Versandkosten,
            unabhängig vom Bestellwert. Weitere Informationen finden Sie unter
            <Link href='/zahlung-und-versand'> Zahlung & Versand </Link>.
            {germanyOnly
              ? ' Wir liefern ausschließlich innerhalb Deutschlands.'
              : <> Wir liefern auch ins Ausland. Mehr dazu können Sie im Link <Link href='/auslandsversandkosten'>Auslandsversandkosten </Link> erfahren.</>
            }
          </Typo>
      }

      {secondaryHtml
        ? <Box>{parse(secondaryHtml)}</Box>
        : <Typo>
            *² Gilt für Lieferungen nach Deutschland. Wenn Sie bei uns im Rahmen
            einer Bestellung mehrere Artikel bestellen, für die unterschiedliche
            Lieferzeiten gelten, versenden wir die Ware in einer gemeinsamen
            Sendung, sofern wir mit Ihnen nichts anderes vereinbart haben. In diesem
            Fall gilt für die Warensendung insgesamt die Lieferzeit, die für den
            Artikel Ihrer Bestellung mit der längsten Lieferzeit gilt.
          </Typo>
      }

    </Container>
  </div>
}

export default Fussnoten
